"use client";
import styled from "../../../client-utils/styled/styled.js";
import Badge from "../../../components/atoms/Badge/index.js";
// import styles
import { badgeClasses } from "@mui/material/Badge";
import { DOUBLE } from "../../../constants/numbers.consts.js";
export const FloatingBadgeAtomComponent = styled(Badge, {
    name: "SdbFloatingBadge",
    slot: "Root",
})(({ theme }) => ({
    right: theme.spacing(-DOUBLE),
    top: "50%",
    [`& .${badgeClasses.standard}`]: {
        top: "50%",
        translateY: "-50%",
    },
}));
export default FloatingBadgeAtomComponent;
